import React, { useEffect, useState, useCallback } from 'react';

import {
  CrossIcon,
  AttentionIcon,
  CheckmarkIcon,
  InfoIcon,
} from '../../../assets/svg/SVGComponents';
import { IToastMessage, useToast } from '../../../hooks/toast';

import { Container, Content } from './styles';

interface ToastProps {
  message: IToastMessage;
}

const icons = {
  info: (
    <InfoIcon width="1.33rem" stroke="#2B80B8" fill="none" strokeWidth={2} />
  ),

  success: (
    <CheckmarkIcon
      width="1.33rem"
      stroke="#0EA581"
      fill="none"
      strokeWidth={2}
    />
  ),

  error: (
    <AttentionIcon
      width="1.33rem"
      stroke="#FF2E3E"
      fill="none"
      strokeWidth={2}
    />
  ),
  warn: (
    <AttentionIcon
      width="1.33rem"
      stroke="#FFBA08"
      fill="none"
      strokeWidth={2}
    />
  ),
};

const DISMISS_DELAY = 3000;
const EXIT_DURATION = 250;

const Toast: React.FC<ToastProps> = ({ message }) => {
  const { removeToast } = useToast();
  const [isLeaving, setIsLeaving] = useState(false);

  const startExit = useCallback(() => {
    setIsLeaving(true);
  }, []);

  // auto-dismiss: begin exit animation after DISMISS_DELAY
  useEffect(() => {
    const timer = setTimeout(startExit, DISMISS_DELAY);
    return () => clearTimeout(timer);
  }, [message.id, startExit]);

  // when leaving: wait for CSS animation to finish, then remove
  useEffect(() => {
    if (!isLeaving) return;
    const timer = setTimeout(() => removeToast(message.id), EXIT_DURATION);
    return () => clearTimeout(timer);
  }, [isLeaving, message.id, removeToast]);

  return (
    <Container type={message.type} $isLeaving={isLeaving}>
      <Content>
        {icons[message.type || 'info']}
        <div>
          <p>
            <strong>{message.expression && message.expression} </strong>
            {message.description}
          </p>
        </div>

        <button onClick={startExit} type="button">
          <CrossIcon width="1rem" stroke="#63646A" strokeWidth={1.5} />
        </button>
      </Content>
    </Container>
  );
};

export default Toast;
